import React from 'react'
import { Trans } from 'react-i18next'
import { View, ViewProps } from 'react-native'
import { Text } from 'zens-storybook'

const ScheduleModeDescription = ({ style }: ViewProps) => (
  <View style={style} testID="ScheduleModeDescription.Container">
    <Text>
      <Trans>
        Chargers light up blue at scheduled times if the workspace was used, indicating these workspaces need to be
        cleaned.
      </Trans>
    </Text>
  </View>
)

ScheduleModeDescription.Skeleton = ({ style }: ViewProps) => (
  <View style={style}>
    <Text.Skeleton />
    <Text.Skeleton />
  </View>
)

export default ScheduleModeDescription

// Retained for when multiple schedule modes are supported again.
// import { Color, RadioGroup, RadioGroupProps, Radius, Spacing, Text } from 'zens-storybook'
// import React from 'react'
// import { Trans } from 'react-i18next'
// import { StyleSheet, View, ViewProps } from 'react-native'
// import { ScheduleMode } from 'zens-store'
//
// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//     flexDirection: 'column',
//     maxWidth: '100%',
//   },
//   option: {
//     flex: 1,
//     marginLeft: 0,
//     marginBottom: Spacing.S,
//   },
//   title: {
//     flex: 1,
//     marginVertical: -3,
//   },
//   description: {
//     marginTop: Spacing.XS,
//   },
//   skeletonOption: {
//     padding: 11,
//     borderRadius: Radius.S,
//     borderWidth: 1,
//     borderColor: Color.calmGrey,
//     marginBottom: Spacing.S,
//     minHeight: 92,
//   },
// })
//
// interface Props extends Omit<RadioGroupProps<ScheduleMode>, 'items'> {
//   onChange?: (value: ScheduleMode) => void
// }
// const ScheduleModeRadioGroup = (props: Props) => {
//   const { onChange, style, optionStyle, ...otherProps } = props
//   const items = [
//     {
//       value: ScheduleMode.Clean,
//       title: (
//         <View style={styles.title}>
//           <Text level={5}>
//             <Trans>Cleaning mode</Trans>
//           </Text>
//           <Text style={styles.description}>
//             <Trans>
//               Select this mode to workspaces to make the charger light up blue at scheduled times if it was used,
//               indicating these workspaces need to be cleaned.
//             </Trans>
//           </Text>
//         </View>
//       ),
//     },
//     // {
//     //   value: ScheduleMode.Block,
//     //   title: (
//     //     <View style={styles.title}>
//     //       <Text level={5}>
//     //         <Trans>Blocked mode</Trans>
//     //       </Text>
//     //       <Text style={styles.description}>
//     //         <Trans>
//     //           Select this mode to make the charger light up red at scheduled times, indicating the workspace is blocked
//     //           and cannot be used.
//     //         </Trans>
//     //       </Text>
//     //     </View>
//     //   ),
//     // },
//   ]
//
//   return (
//     <RadioGroup
//       style={[styles.container, style]}
//       optionStyle={[styles.option, optionStyle]}
//       items={items}
//       onSelect={onChange}
//       testID="ScheduleModeRadioGroup.Container"
//       {...otherProps}
//     />
//   )
// }
//
// interface SkeletonProps extends ViewProps {}
//
// ScheduleModeRadioGroup.Skeleton = (props: SkeletonProps) => {
//   const { style, ...otherProps } = props
//   return (
//     <View style={[styles.container, style]} {...otherProps}>
//       <View style={styles.skeletonOption}>
//         <Text.Skeleton />
//         <Text.Skeleton />
//         <Text.Skeleton />
//       </View>
//       <View style={styles.skeletonOption}>
//         <Text.Skeleton />
//         <Text.Skeleton />
//         <Text.Skeleton />
//       </View>
//     </View>
//   )
// }
//
// export default ScheduleModeRadioGroup
